import { PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
var PaymentStatusPipe = /** @class */ (function () {
    function PaymentStatusPipe(translateService) {
        this.translateService = translateService;
    }
    PaymentStatusPipe.prototype.transform = function (statusName) {
        if (statusName) {
            if (statusName === 'pending') {
                return this.translateService.instant('MAINTENANCES.PAYMENTS.STATUS_OPTIONS.PENDING');
            }
            else if (statusName === 'approved') {
                return this.translateService.instant('MAINTENANCES.PAYMENTS.STATUS_OPTIONS.APPROVED');
            }
            else if (statusName === 'rejected') {
                return this.translateService.instant('MAINTENANCES.PAYMENTS.STATUS_OPTIONS.REJECTED');
            }
        }
        return null;
    };
    return PaymentStatusPipe;
}());
export { PaymentStatusPipe };
